export enum DayOfWeek {
    Sunday      = 0,
    Monday      = 1,
    Tuesday     = 2,
    Wednesday   = 3,
    Thursday    = 4,
    Friday      = 5,    
    Saturday    = 6
}

export const DayOfWeekMetadata = {
    '0' : {
        display: 'Sunday',
        value: 0
    },
    '1' : {
        display: 'Monday',
        value: 1
    },
    '2' : {
        display: 'Tuesday',
        value: 2
    },
    '3' : {
        display: 'Wednesday',
        value: 3
    },
    '4' : {
        display: 'Thursday',
        value: 4
    },
    '5' : {
        display: 'Friday',
        value: 5
    },
    '6' : {
        display: 'Saturday',
        value: 6
    }
}